const SET_TIMEOUT = 1;
const CLEAR_TIMEOUT = 2;
const TIMEOUT_TICK = 3;

export {
  SET_TIMEOUT,
  CLEAR_TIMEOUT,
  TIMEOUT_TICK,
};
